import React from 'react';
import { Checkbox, FloatingDropdown } from 'wix-ui-tpa/cssVars';
import type { FloatingDropdownOptionProps } from 'wix-ui-tpa';
import { classes } from './FilterDropdown.st.css';
import { FilterOption } from '../../../../types/types';
import { FilterDropdownDataHooks } from './const';

export type FilterDropdownProps = {
  label: string;
  options: FilterOption[];
  onChange: (selectedOption: FilterOption) => void;
  dataHook?: string;
};

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  label,
  onChange,
  options: filterOptions,
  dataHook,
}) => {
  const options: FloatingDropdownOptionProps[] = filterOptions.map(
    ({ id, value, selected }) => ({
      value,
      id,
      icon: (
        <Checkbox
          key={id}
          checked={selected}
          onChange={({ checked }) => onChange({ id, value, selected: checked })}
        />
      ),
    }),
  );

  return (
    <div className={classes.root} data-hook={FilterDropdownDataHooks.Main}>
      <FloatingDropdown
        removeElementMinWidth
        label={label}
        onChange={onChange}
        options={options}
        data-hook={dataHook}
      />
    </div>
  );
};
